export const GAME_VIEW = {
    EMAIL: "EMAIL",
    GAME: "GAME",
    REWARD: "REWARD"
}